module.exports = __webpack_public_path__ + "media/images/buskowitz-503f0fd1f5188fb2f16e9a2590d30ce8.png";